import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Login } from '../_models/index';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpRequestService } from '../_services/index';
import { catchError, map } from 'rxjs/operators';
import { SmagAccountService } from '../framework/auth/services';
import { localStorageService } from './local-storage.service';
import { isNullOrEmptyString } from '../_helpers';


@Injectable()
export class AuthenticationService {
    private baseUrl = environment.BeApiOperational.url;
    private jwtHelper: JwtHelperService = new JwtHelperService();
    private currentUser: Login|null;

    //notifie les abonnés (ex DashboardComponent) qu'une réauthentification vient de rafraichir les tokens
    private _refreshAfterReAuthenticated = new BehaviorSubject<boolean>(false);
    // Observable to notify subscribers when re-authentication has refreshed the tokens
    public onRefreshAfterReAuthenticated: Observable<boolean> = this._refreshAfterReAuthenticated.asObservable();
    // Setter to update the refreshAfterReAuthenticated status
    protected set refreshAfterReAuthenticated(value: boolean) {
        this._refreshAfterReAuthenticated.next(value);
    }

    constructor(private httpRequestService: HttpRequestService, private smagAuth : SmagAccountService) { 

        this.currentUser=null;

    }

   /**
    * return true if token Legacy or smag token expired
    *  Checks if either the legacy token or the Smag token has expired.
    * @returns 
    */
    public AreTokensExpired(): boolean {
      const currentuser = localStorageService.GetJsonLogin(true);
      if (!currentuser || !currentuser.token || !currentuser.smag_token) {
          return true;
      }
      const tokenLegacy = currentuser.token;
      const tokenSmag = currentuser.smag_token;
      if (this.jwtHelper.isTokenExpired(tokenLegacy) == true || (!isNullOrEmptyString(tokenSmag) && this.jwtHelper.isTokenExpired(tokenSmag) == true)) {
        return true;
      }
      return false;
    }

    ///return if token smag (smaglink) is expired
    public isSmagTokenExpired(): boolean | null {
        const currentuser = localStorageService.GetJsonSmagTokens(true);
       
        if (currentuser && currentuser.smag_token) {
            const token = currentuser.smag_token;

            return this.jwtHelper.isTokenExpired(token);
        } else {
            return null;
        }

    }

    /**
     * Enregsitrement en session Login (Current_user)+ this.currentUser
     * @param user données legacy login décryptés
     * @param username nom utilisateur à attribuer ou null
     * @returns 
     */
    private saveLoginUserInfo(user: any, username: string|null = null):Login|null {
        if (user && user.Token) {
            const loginModel = new Login();
            loginModel.username = username ?? "";
            loginModel.userid = user.UserId;
            loginModel.token = user.Token;
            loginModel.refresh_token = user.Refresh_Token;
            localStorageService.SetCurrentUser(loginModel);
            // store user details and jwt token in local storage to keep user logged in between page refreshes
           
            this.currentUser = loginModel;
        }
        return user;
    }
    /**
     * Récupération du legacy token de la session
     * @returns 
     */
    public getLegacyToken() {
        const currentuser = localStorageService.GetJsonLogin(true);
        if (currentuser && currentuser.token) {
            const token = currentuser.token;
            const legacyToken = this.jwtHelper.decodeToken(token).LegacyToken;
            if (legacyToken) {
                localStorageService.set('currentLegacyToken', legacyToken);
                return legacyToken;
            } else {
                throw new Error('Current user does not have jwt');
            }
        }else{
               throw new Error('Current user is null or empty token');
        }

    }


    /**
     * Refresh Smag Token & Legacy Token depuis le current
     * @param smag_refreshToken refresh smag token
     * @param userId filtre sur user legacy id (int)
     */
    public refreshSmagUserTokens(): Observable<boolean>{
         this.refreshAfterReAuthenticated = false;
            const memSmagUser = localStorageService.GetJsonSmagUser(true);
            if(!memSmagUser || !memSmagUser.smag_refresh_token){   
                this.refreshAfterReAuthenticated = false;
                  return of(false);
            } 
      return  this.smagAuth.refreshSmagAccount(memSmagUser.smag_refresh_token,memSmagUser.id).pipe(
      map(
            (userTokenResult:any)=>{
                if(userTokenResult && userTokenResult.LegacyToken && userTokenResult.SmagToken && userTokenResult.SmagRefreshToken){     
                    memSmagUser.jarvis_token = userTokenResult.LegacyToken;
                    memSmagUser.smag_refresh_token =userTokenResult.SmagRefreshToken;
                    memSmagUser.smag_token =userTokenResult.SmagToken;
                    localStorageService.SetSmagUser(memSmagUser);

                    const memCurrentUser = localStorageService.GetJsonCurrentUserBrut();
                    memCurrentUser.token= userTokenResult.LegacyToken;
                    memCurrentUser.smag_token= userTokenResult.SmagToken;
                    localStorageService.SetCurrentUser(memCurrentUser);
                    this.refreshAfterReAuthenticated = true;
                    return true;
                }else{
                     console.log('Erreur durant la réauthentification, aucun token en réponse');
                     this.refreshAfterReAuthenticated = false;
                    return false;
                }
            },
           
        ),
      catchError((error: any) => {
        // il y a deja l'erreur
        this.refreshAfterReAuthenticated = false;
        return of(false);
      }));
    }

    /**
     * Contrôle & parse les données utilisateur du token legacy
     * @param currentToken 
     * @returns 
     */
    public verifyLegacyToken(currentToken: string):Observable<any|boolean> {
        const token = localStorageService.get('currentToken');
        if (token) {
            //controle le token passe dans le request Header
            return this.httpRequestService.GetEmptyBodyRequest(this.baseUrl + 'api/legacy/validejwt', 'verifyToken')
                .pipe(map((response: Response) => {
                    return this.saveLoginUserInfo(response);
                }));
        }else{
            return of(false);
        }
    }

    public logout() {
        // remove user from local storage to log user out
        // localStorage.removeItem('currentUser');
        // localStorage.removeItem('currentToken');
        // localStorage.removeItem('currentLegacyToken');
        // localStorage.clear();
    }


}
